export function useIdPrefix(idPrefix: string, idSuffix: string): string {
    return `${idPrefix}-${idSuffix}`;
}
